import { tokens } from '../theme';

// Colour of a number in reports by what it means for the seller, not only by its sign.
//   signed  — result figures (profit, payout, margin): plus is green, minus is red.
//   expense — costs that WB shows as positive numbers (commission, logistics, fines):
//             a charge is red, a negative cost (refund, correction in the seller's favour) is green.
// Zero and missing values stay muted so a table of zeros does not look alarming.
export function toneOf(value, kind = 'signed') {
  if (value === null || value === undefined || value === '') return 'none';
  const n = Number(value);
  if (Number.isNaN(n) || Math.abs(n) < 0.005) return 'zero';
  const gain = kind === 'expense' ? n < 0 : n > 0;
  return gain ? 'positive' : 'negative';
}

const COLORS = {
  positive: { fg: tokens.positive, bg: tokens.positiveSoft },
  negative: { fg: tokens.negative, bg: tokens.negativeSoft },
  zero: { fg: tokens.inkMuted, bg: 'transparent' },
  none: { fg: tokens.inkMuted, bg: 'transparent' },
};

export const toneColor = (value, kind) => COLORS[toneOf(value, kind)].fg;

// A soft pill for key totals (payout, profit): tinted background, coloured number.
export function tonePill(value, kind) {
  const t = toneOf(value, kind);
  const c = COLORS[t];
  if (t === 'zero' || t === 'none') return { color: c.fg };
  return {
    color: c.fg,
    backgroundColor: c.bg,
    borderRadius: '8px',
    px: 1,
    py: 0.375,
    display: 'inline-block',
    lineHeight: 1.4,
  };
}
